const React = require("react");
const T = require("prop-types");
const Style = require("./styles.scss");

module.exports = class Users extends React.Component {
    static propTypes = {
        isFetching: T.bool.isRequired,
        items: T.array,
        hasFetchedAll: T.bool.isRequired,
        currentUser: T.object.isRequired,

        deleteUser: T.func.isRequired,
        fetchUsers: T.func.isRequired
    };

    state = {
        items: null,
        searchInput: ""
    };

    constructor(props, context) {
        super(props, context);

        this.deleteUser = this.deleteUser.bind(this);
        this.onSearchChange = this.onSearchChange.bind(this);
    }

    componentDidMount() {
        if (!this.props.hasFetchedAll) {
            this.props.fetchUsers();
        }
    }

    deleteUser(user) {
        const msg =
            `You are able to delete this user:\n\nEmail: ${user.email}` +
            `\nName: ${user.firstName} ${user.lastName}` +
            `\n\nTo confirm, please write "delete" in the text box.`;

        if (prompt(msg, "") === "delete") {
            this.props.deleteUser(user.id);
        }
    }

    updateItems(search) {
        let items;

        if (!search) {
            items = [...this.props.items];
        } else {
            items = this.props.items.filter(item => {
                const firstName = item.firstName || "";
                const lastName = item.lastName || "";

                return (
                    item.email.toLowerCase().includes(search) ||
                    firstName.toLowerCase().includes(search) ||
                    lastName.toLowerCase().includes(search)
                );
            });
        }

        this.setState({ items });
    }

    onSearchChange(e) {
        this.setState({
            searchInput: e.target.value
        });

        this.updateItems(e.target.value);
    }

    renderUsersTable() {
        const sortedItems = this.state.items.sort((a, b) => a.email > b.email);

        const items = sortedItems.map(u => (
            <tr key={u.id}>
                <td>{u.email}</td>
                <td>
                    {u.lastName}, {u.firstName}
                </td>
                <td>{u.credits}</td>
                <td>{u.isAdmin ? "Yes" : "No"}</td>
                <td>
                    {!u.isAdmin && u.id !== this.props.currentUser.id ? (
                        <button onClick={() => this.deleteUser(u)}>
                            DELETE
                        </button>
                    ) : null}
                </td>
            </tr>
        ));

        return (
            <table className={Style.usersTable}>
                <thead>
                    <tr>
                        <th>Email</th>
                        <th>Name</th>
                        <th>Credits</th>
                        <th>Admin</th>
                        <th>Manage</th>
                    </tr>
                </thead>
                <tbody>{items}</tbody>
            </table>
        );
    }

    renderSearchField() {
        return (
            <div>
                <input
                    className={Style.searchField}
                    type="text"
                    placeholder="Search by email/name"
                    value={this.state.searchInput}
                    onChange={this.onSearchChange}
                />
            </div>
        );
    }

    renderUserCount() {
        let text = `Showing ${this.state.items.length} `;
        text += this.state.items.length === 1 ? "user" : "users";

        if (this.state.searchInput) {
            text += " (filtered)";
        }

        return <p>{text}</p>;
    }

    render() {
        if (this.props.items && this.state.items === null) {
            this.updateItems(this.state.search);
        }

        return (
            <div>
                <h2>Manage Users</h2>
                {this.state.items === null ? (
                    "Loading..."
                ) : (
                    <div>
                        {this.renderUsersTable()}
                        {this.renderSearchField()}
                        {this.renderUserCount()}
                    </div>
                )}
            </div>
        );
    }
};



// WEBPACK FOOTER //
// ./src/routes/admin-users/components/Users.js